import { useEffect } from 'react'

import { usePathname } from 'next/navigation'
import useLocalStorage from 'react-use/lib/useLocalStorage'

import { isTransactionPage } from '~/components/Layout/isTransactionPage'

export function useLastActivePath() {
  const pathname = usePathname()
  const [lastActivePath, setLastActivePath] = useLocalStorage<string>(
    'splits.sidebar.lastActivePath',
    '/',
  )

  const isOnTransactionPage = isTransactionPage(pathname)

  useEffect(() => {
    if (!isOnTransactionPage) setLastActivePath(pathname)
  }, [pathname, isOnTransactionPage, setLastActivePath])

  // Return the effective pathname for sidebar active state
  const effectivePathname = isOnTransactionPage
    ? lastActivePath || '/'
    : pathname

  return effectivePathname
}
